import { render, staticRenderFns } from "./BotManage.vue?vue&type=template&id=1faaf730&scoped=true&"
import script from "./BotManage.vue?vue&type=script&lang=js&"
export * from "./BotManage.vue?vue&type=script&lang=js&"
import style0 from "./BotManage.vue?vue&type=style&index=0&id=1faaf730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faaf730",
  null
  
)

export default component.exports